module.exports = "/assets/data/a7a11edb41c8603575a145f1e4a765d5-SE16.data.json";